import React from 'react';
import { useParams } from 'react-router-dom';
import CompanyDashboardShell from './CompanyDashboardShell';

const SisterCompanyDashboard = () => {
  const { companyId } = useParams();

  if (!companyId) {
    return <div className="cd-error">Company not specified.</div>;
  }

  return <CompanyDashboardShell companyId={companyId} />;
};

export default SisterCompanyDashboard;
